import f from '@app/icare/db/schema/field/f'
import { CareServiceId } from '@app/icare/entities/careService/schema/CareService'
import { ClinicId } from '@app/icare/entities/clinic/schema/Clinic'
import { CostCarrierId } from '@app/icare/entities/costCarrier/schema/CostCarrier'
import { DoctorId } from '@app/icare/entities/doctor/schema/Doctor'
import { MedicalTechnologyId } from '@app/icare/entities/medicalTechnology/schema/MedicalTechnology'
import type { PatientForm } from '@app/icare/entities/patientForm/schema/PatientForm'
import { PharmacyId } from '@app/icare/entities/pharmacy/schema/Pharmacy'
import { msg } from '@lingui/core/macro'
import { defineEnum } from '@pkg/shared/utils/enum-builder'
import { z } from 'zod'
import { ContactablePersonSchema } from '../common'
import { PatientFormCommonSchema } from './PatientFormCommon'
import { PatientFormTypeEnum } from './PatientFormType'

export const SupplySuggestEnum = defineEnum({
  select: msg`Auswählen`,
  suggest: msg`Vorschlagen`,
  none: msg`Keine`,
})

export type SupplySuggestType = typeof SupplySuggestEnum.$.Type

export const PatientSupplyStatusEnum = defineEnum({
  new: msg`Neu`,
  approved: msg`Abgeschlossen`,
})

export type PatientSupplyStatusType = typeof PatientSupplyStatusEnum.$.Type

export const PatientSupplyFormSchema = PatientFormCommonSchema.extend({
  status: z.enum(PatientSupplyStatusEnum.$.zodEnum()).default(PatientSupplyStatusEnum.new),
  statusChangedAt: z.string().datetime().nullish().default(null),
  type: z.literal(PatientFormTypeEnum.PatientSupply).default(PatientFormTypeEnum.PatientSupply),
  form: z.object({
    signature: z.string().nullish(),
    legalRepresentative: ContactablePersonSchema.extend({
      birthdate: f.date().nullish(),
    })
      .nullish()
      .default(() => null),
    costCarrier: z
      .object({
        privateInsured: z.boolean().default(false),
        value: CostCarrierId.ref.nullish(),
      })
      // ._superRefine((data, ctx) => {
      //   if (data.privateInsured === false && data.value === null) {
      //     ctx.addIssue({
      //       code: z.ZodIssueCode.custom,
      //       path: ['value'],
      //       message: 'required',
      //     })
      //   }
      // })
      .default(() => ({ privateInsured: false, value: null })),
    doctor: z
      .object({
        value: DoctorId.ref.nullish(),
      })
      .default(() => ({ value: null })),
    clinic: z
      .object({
        value: ClinicId.ref.nullish(),
      })
      .default(() => ({ value: null })),
    careService: z
      .object({
        select: z.enum(SupplySuggestEnum.$.zodEnum()).default(SupplySuggestEnum.none),
        value: CareServiceId.ref.nullish(),
      })
      // ._superRefine((data, ctx) => {
      //   if (data.select === SupplySuggestEnum.select && data.value === null) {
      //     ctx.addIssue({
      //       code: z.ZodIssueCode.custom,
      //       path: ['value'],
      //       message: 'required',
      //     })
      //   }
      // })
      .default(() => ({ select: SupplySuggestEnum.none, value: null })),

    medicalTechnology: z
      .object({
        select: z.enum(SupplySuggestEnum.$.zodEnum()).default(SupplySuggestEnum.none),
        value: MedicalTechnologyId.ref.nullish(),
      })
      // ._superRefine((data, ctx) => {
      //   if (data.select === SupplySuggestEnum.select && data.value === null) {
      //     ctx.addIssue({
      //       code: z.ZodIssueCode.custom,
      //       path: ['value'],
      //       message: 'required',
      //     })
      //   }
      // })
      .default(() => ({ select: SupplySuggestEnum.none, value: null })),

    pharmacy: z
      .object({
        select: z.enum(SupplySuggestEnum.$.zodEnum()).default(SupplySuggestEnum.none),
        value: PharmacyId.ref.nullish(),
      })
      // ._superRefine((data, ctx) => {
      //   if (data.select === SupplySuggestEnum.select && data.value === null) {
      //     ctx.addIssue({
      //       code: z.ZodIssueCode.custom,
      //       path: ['value'],
      //       message: 'required',
      //     })
      //   }
      // })
      .default(() => ({ select: SupplySuggestEnum.none, value: null })),
  }),
})

export type PatientSupplyForm = z.infer<typeof PatientSupplyFormSchema>

export const isPatientSupplyForm = (data: PatientForm): data is PatientSupplyForm => {
  return data.type === PatientFormTypeEnum.PatientSupply
}
